import { SOL_SYMBOL_ICON_PATH, TOKEN_SYMBOL_ICON_PATH } from '@/consts/imgPath';
import { useStores } from '@/stores';
import clsx from 'clsx';
import { useState } from 'react';

interface IProps {
  isChecked: boolean;
  onClickCheckbox: () => void;
  onClickWithdrawBtn: () => void;
  exitViewType: string;
  onChangeExitViewType: (type: string) => void;
  isWithdrawConfirmModalOpen: boolean;
  isWithdrawCompleteModalOpen: boolean;
  onClickWithdrawConfirmModalClose: () => void;
  onClickWithdrawConfirmModalYes: () => void;
  onClickWithdrawCompleteModalConfirm: () => void;
}

const ExitView = ({
  isChecked,
  onClickCheckbox,
  onClickWithdrawBtn,
  exitViewType,
  onChangeExitViewType,
  isWithdrawConfirmModalOpen,
  isWithdrawCompleteModalOpen,
  onClickWithdrawConfirmModalClose,
  onClickWithdrawConfirmModalYes,
  onClickWithdrawCompleteModalConfirm,
}: IProps) => {
  const [isConfirmChecked, setIsConfirmChecked] = useState<boolean>(false);
  const { userStore } = useStores();

  const onChangeConfirmCheck = () => {
    setIsConfirmChecked(!isConfirmChecked);
  }




  return (
    <>
      {exitViewType === 'exit' && (
        <div className="delete-account-content setting-container container-style2">
          <div className="delete-account-card" >
            <div className="delete-account-icon" >
              <img src="images/security-icon.png" alt="GDF" className="security-icon-image" />
            </div>

            <h2 className="delete-account-title text-lg font-bold" >안전한 서비스 이용을 위해 계정 정보와<br />전자지갑 보안 설정을 관리해야 합니다.</h2>

            <div className="delete-account-notice" >
              <p className="delete-notice-main text-base font-medium" >아래 항목들을 주기적으로 확인하고<br />필요한 설정을 업데이트해 주세요.</p>
            </div>

            <ul className="delete-account-list" >
              <li className="delete-list-item text-sm font-normal" >
                <span className="bullet">•</span>
                <span className="list-text">비밀번호와 PIN 비밀번호는 정기적으로 변경하는 것을 권장드립니다.</span>
              </li>
              <li className="delete-list-item text-sm font-normal" >
                <span className="bullet">•</span>
                <span className="list-text">전자지갑과 관련된 주요 정보는 사용자 기기에서 안전하게 암호화되어 관리됩니다.</span>
              </li>
              <li className="delete-list-item text-sm font-normal" >
                <span className="bullet">•</span>
                <span className="list-text">로그인 기록, 지갑 잔액, 계정 정보 등은 안전한 서비스 이용을 위해 필요한 범위 내에서 관리·확인됩니다.</span>
              </li>
              <li className="delete-list-item text-sm font-normal" >
                <span className="bullet">•</span>
                <span className="list-text">의심스러운 활동이나 로그인 이력이 발견될 경우 즉시 비밀번호를 변경해주세요.</span>
              </li>
              <li className="delete-list-item text-sm font-normal" >
                <span className="bullet">•</span>
                <span className="list-text">기기 변경, 분실, 비정상적인 접속 시에는 보안상의 이유로 일부 기능이 제한될 수 있습니다.</span>
              </li>
              <li className="delete-list-item text-sm font-normal" >
                <span className="bullet">•</span>
                <span className="list-text">안전한 계정 사용과 자산 보호를 위해 항상 최신 보안 설정을 유지해 주세요.</span>
              </li>
            </ul>

            <button type="button" className="account-delete-btn text-sm font-normal" id="deleteAccountBtn" onClick={() => onChangeExitViewType('check')}>회원탈퇴</button>
          </div>

        </div>
      )}





      {exitViewType === 'check' && (
        <div className="delete-account-content setting-container container-style2">
          <div className="delete-account-card" >
            <div className="delete-account-icon" >
              <img src={"/images/gdf-logo-large.png"} alt="BI" className="delete-icon-image" />
            </div>

            <h2 className="delete-account-title text-lg font-bold" >탈퇴 전 확인하세요.</h2>

            <div className="delete-account-notice" >
              <p className="delete-notice-main text-base font-medium" >탈퇴 후에는 이용중인 모든 전자지갑에 접근할 수 없으며,<br />모든 데이터는 복구가 불가능합니다.</p>
            </div>

            <ul className="delete-account-list" >
              <li className="delete-list-item text-sm font-normal" >
                <span className="bullet">•</span>
                <span className="list-text">탈퇴를 진행하기 전에 전자지갑에 남아 있는 잔액을 반드시 미리 출금해주세요.</span>
              </li>
              <li className="delete-list-item text-sm font-normal gray" >
                <span className="list-text-indent">회원 탈퇴가 완료되면 지갑 내 잔액을 복구하거나 거래 내역을 조회할 수 있는 방법이 없습니다.</span>
              </li>
              <li className="delete-list-item text-sm font-normal" >
                <span className="bullet">•</span>
                <span className="list-text">탈퇴 시 모든 거래 내역과 계정 관련 정보가 함께 삭제되며, 삭제된 정보는 어떠한 방법으로도 복구할 수 없습니다.</span>
              </li>
            </ul>

            <div className="asset-balance-notice" >
              <div className="asset-balance-title text-base font-bold" >{userStore.user?.name}님의 현 자산 상황</div>

              <div className="asset-balance-item" >
                <div className="asset-balance-info" >
                  <img src={TOKEN_SYMBOL_ICON_PATH} alt="골든파이낸스" className="asset-balance-icon" />
                  <span className="asset-balance-name text-sm font-semibold" >골든파이낸스</span>
                </div>
                <span className="asset-balance-amount text-sm font-semibold" >{userStore.myAsset?.tokenAsset?.balance} {userStore.myAsset?.tokenAsset?.symbol}</span>
              </div>

              <div className="asset-balance-item" >
                <div className="asset-balance-info" >
                  <img src={SOL_SYMBOL_ICON_PATH} alt="솔라나" className="asset-balance-icon" />
                  <span className="asset-balance-name text-sm font-semibold" >솔라나</span>
                </div>
                <span className="asset-balance-amount text-sm font-semibold" >{userStore.myAsset?.coinAsset?.balance} {userStore.myAsset?.coinAsset?.symbol}</span>
              </div>

              <p className="asset-balance-warning text-sm font-semibold center" >※ 탈퇴 후에는 전자지갑 접근 권한이 종료되므로,<br />남아 있는 자산을 사용할 수 없습니다.</p>
            </div>

            <div className="delete-account-checkbox" >
              <input
                type="checkbox"
                id="deleteConfirm"
                className="delete-checkbox"
                checked={isConfirmChecked}
                onChange={onChangeConfirmCheck}
              />
              <label htmlFor="deleteConfirm" className="delete-checkbox-label text-sm font-normal" >안내사항을 모두 확인하였으며, 이에 동의합니다.</label>
            </div>

            <button
              type="button"
              className={clsx('delete-account-btn btn-primary text-lg font-semibold', {
                active: isConfirmChecked,
              })}
              // className="delete-account-btn btn-primary text-lg font-semibold"
              id="deleteAccountBtn"
              disabled={!isConfirmChecked}
              onClick={onClickWithdrawBtn}
            >
              탈퇴하기
            </button>
          </div>
        </div>
      )}

      {/* 회원탈퇴 확인 모달 */}
      <div
        className={clsx('modal-overlay', !isWithdrawConfirmModalOpen && 'hidden')}
        id="deleteAccountConfirmModal"
      >
        <div className="modal-content modal-medium">
          <button type="button" className="modal-close" onClick={onClickWithdrawConfirmModalClose}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <h2 className="modal-delete-title text-base font-bold">
              탈퇴 후에는
              <br />
              전자지갑 자산을 복구할 수 없습니다.
            </h2>

            <p className="modal-delete-question text-base font-bold">정말로 탈퇴하시겠습니까?</p>

            <div className="modal-confirm-buttons">
              <button
                type="button"
                className="modal-confirm-no text-lg font-semibold"
                onClick={onClickWithdrawConfirmModalClose}
              >
                아니오
              </button>
              <button
                type="button"
                className="modal-confirm-yes text-lg font-semibold"
                onClick={onClickWithdrawConfirmModalYes}
              >
                예
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* 회원탈퇴 완료 모달 */}
      <div
        className={clsx('modal-overlay', !isWithdrawCompleteModalOpen && 'hidden')}
        id="deleteAccountCompleteModal"
      >
        <div className="modal-content modal-medium">
          <button type="button" className="modal-close" onClick={onClickWithdrawCompleteModalConfirm}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <div className="modal-icon-success">
              <img src="./images/success-icon.png" alt="성공" className="modal-icon" />
            </div>

            <h2 className="modal-message-title text-lg font-bold">회원탈퇴가 완료되었습니다.</h2>

            <button
              type="button"
              className="modal-button text-lg font-semibold"
              onClick={onClickWithdrawCompleteModalConfirm}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </>

    // <div className="container-style2">
    //   <div className="exit">
    //     <div className="inner">
    //       <div className="img">
    //         <img src={TOKEN_SYMBOL_ICON_PATH} alt="BI" />
    //       </div>
    //       <h3 className="body-n-n">탈퇴 전 확인하세요.</h3>
    //       <p className="body-n-n">
    //         탈퇴 후에는 이용중인 모든 전자지갑에 <br /> 접근할 수 없으며, <br /> 모든 데이터는 복구가 불가능합니다.
    //       </p>
    //       <div className="txt-box-exit">
    //         <p className="body-s-n">
    //           • 탈퇴 전에 전자지갑에 남아 있는 잔액을 반드시 <br /> 미리 출금해주세요.
    //         </p>
    //         <p className="body-s-n">
    //           <span>
    //             탈퇴 후에는 지갑 내 잔액을 복구하거나 조회할 수 있는 <br /> 방법이 없습니다.
    //           </span>
    //         </p>
    //         <p className="body-s-n">
    //           • 탈퇴 후에는 모든 거래 내역 및 계정 관련 정보가 <br /> 삭제되며, 이 정보는 복구할 수 없습니다.
    //         </p>
    //       </div>
    //       <div className="checkbox-area">
    //         <input type="checkbox" id="confirmCheck" checked={isChecked} onChange={onClickCheckbox} />
    //         <label htmlFor="confirmCheck">안내사항을 모두 확인하였으며, 이에 동의합니다.</label>
    //       </div>
    //       <Button
    //         caption="탈퇴하기"
    //         className={clsx('l-button solid', {
    //           disabled: !isChecked,
    //         })}
    //         disabled={!isChecked}
    //         onClick={onClickWithdrawBtn}
    //       />
    //     </div>
    //   </div>
    // </div>
  );
};

export default ExitView;
